import { connect } from 'react-redux'

import { getTimeline } from '@selectors/data/timeline_selectors.js'
import { loadShareable } from '../actions.js'
import { selectShareable, selectShareableStatus, selectShareableError } from '../reducers/index.js'
import ClassicSharer from '../components/ClassicSharer.tsx'

const mapStateToProps = (state, props) => {
  const { shareableType, shareableId } = props
  const shareable = selectShareable(state, props)
  const status = selectShareableStatus(state, props)
  const error = selectShareableError(state, props)

  // also select the resource
  let resource = null
  if (shareable) {
    switch (shareableType.toLowerCase()) {
      case 'timeline':
        resource = getTimeline(state, { timelineId: shareableId })
        break
      default:
        break
    }
  }
  return {
    shareableType,
    shareableId,
    shareable,
    resource,
    status,
    error,
    ...props,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    loadShareable: (shareableId, shareableType) => {
      dispatch(loadShareable({ shareableId, shareableType }))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassicSharer)
